<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
    <Copyright :no-bg="isOS" />
  </section>
</template>

<script>
import Copyright from '@/components/Copyright'
import { isOS } from '../../utils/constant'
export default {
  name: 'AppMain',
  components: {
    Copyright,
  },
  data() {
    return {
      isOS: isOS()
    }
  },
  computed: {
    key() {
      return this.$route.path
    },

  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.app-main {
  width: 100%;
  position: relative;
  overflow: hidden;
  background: $bgMain;
}
</style>
